export default class Transport {
	constructor({ direction, transportInfo, device, sendRequest }) {
		console.debug('transport constructor');
		this._direction = direction;
		this._device = device;
		this._transportInfo = transportInfo;
		this._transport = null;
		this._sendRequest = sendRequest;
	}

	async create() {
		if (this._direction === 'send') {
			console.debug('create send transport');
			this._transport = await this._device.createSendTransport(this._transportInfo);
		} else {
			console.debug('create receive transport');
			this._transport = await this._device.createRecvTransport(this._transportInfo);
		}

		this._transport.on('connect', async ({ dtlsParameters }, callback, errback) => {
			console.debug('transport connect');
			try {
				await this._sendRequest('transport/connect', { transportId: this._transport.id, dtlsParameters });
				callback();
			} catch(err) {
				errback(err);
				throw(err);
			}
		});

		this._transport.on('produce', async ({kind, rtpParameters, appData}, callback, errback) => {
			console.debug('transport produce');
			try {
				const producerInfo = await this._sendRequest('stream/addProducer', { kind, streamId: appData.streamId, rtpParameters });
				callback({ id: producerInfo.producerId, kind });
			} catch(err) {
				errback(err);
				throw(err);
			}
		});
	}
}
